module.exports = require("single-spa");